import { render, staticRenderFns } from "./DictionaryList.vue?vue&type=template&id=2e72c692&scoped=true"
import script from "./DictionaryList.vue?vue&type=script&lang=js"
export * from "./DictionaryList.vue?vue&type=script&lang=js"
import style0 from "./DictionaryList.vue?vue&type=style&index=0&id=2e72c692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72c692",
  null
  
)

export default component.exports